// extracted by mini-css-extract-plugin
module.exports = {"Indicator":"PreviewIndicator_Indicator__S2KJB"};